<template>
  <div class="batchDisbursementModal">
    <el-dialog :visible.sync="dialogVisible" class="diglog-card" :title="$t('send_pagements.new_batch_small_disbursement')" :close-on-click-modal="false" width="1100px">

      <div class="step">
        <div class="step-item" style="margin-right: 24px;">
          <div class="section-title" style="color: #F67C7C">
            {{ $t('send_pagements.first_things_first') }}
          </div>
          <div class="batch-tip">
            {{ $t('tips.download_and_fill_template_batch_payments') }}
          </div>
          <div class="download-container">
            <div class="download-middle">
              <div class="download-title-text"> {{ $t('send_pagements.excel_worksheet_template_excel') }}</div>
              <el-button type="primary" size="small" @click="onClickDownloadBtn"><svg-icon icon-class="download" /> {{ $t('send_pagements.download_template') }}</el-button>
              <div class="download-title-text-2">
                {{ $t('tips.latest_template_updated_supported_payment_channels') }}
              </div>
            </div>
          </div>
          <div class="batch-tip-2">
            {{ $t('send_pagements.submit_batch_ease') }}
          </div>
          <div>
            <div class="batch-tip-content">
              <span>1. &nbsp; </span>
              <div>
                <span style="font-weight: 600;">      {{ $t('send_pagements.step_1_title') }} </span>      {{ $t('send_pagements.step_1_content') }}
              </div>
            </div>
            <div class="batch-tip-content">
              <span>2.  &nbsp;</span>
              <div>
                <span style="font-weight: 600;">      {{ $t('send_pagements.step_2_title') }} </span>      {{ $t('send_pagements.step_2_content') }}
              </div>
            </div>
            <div class="batch-tip-content">
              <span>3. &nbsp; </span>
              <div>
                <span style="font-weight: 600;">      {{ $t('send_pagements.step_3_title') }} </span>      {{ $t('send_pagements.step_3_content') }}
              </div>
            </div>
            <div class="batch-tip-content">
              <span>4.  &nbsp;</span>
              <div>
                <span style="font-weight: 600;">      {{ $t('send_pagements.step_4_title') }} </span>      {{ $t('send_pagements.step_4_content') }}
              </div>
            </div>
          </div>

        </div>
        <div class="step-item">
          <div class="section-title" style="color: #364250">
            {{ $t('tips.upload_filled_excel_worksheet_template') }}
          </div>
          <div class="batch-tip">
            {{ $t('tips.upload_filled_excel_using_template_batch_payments') }}
          </div>
          <UploadExcelFile :reference-batch-no="reference_batch_no" @templateFileSuccess="templateFileSuccess" v-on="$listeners" />
          <div
            class="batch-tip-2"
            style="color: #F67C7C"
          >
            {{ $t('tips.following_three_situations_cause_fail') }}
          </div>

          <div>
            <div class="batch-tip-content">
              <span>1. &nbsp; </span>
              <div>
                {{ $t('tips.spaces_in_the_amount') }}
              </div>
            </div>
            <div class="batch-tip-content">
              <span>2.  &nbsp;</span>
              <div>
                {{ $t('tips.spaces_in_the_email_address') }}
              </div>
            </div>
            <div class="batch-tip-content">
              <span>3. &nbsp; </span>
              <div>
                {{ $store.getters.curCountry.country_code === 'ID' ? $t('tips.wallet_account_number_not_start_with_08') : $store.getters.curCountry.country_code === 'TH' ? $t('tips.wallet_account_number_rule'): $t('tips.wallet_account_number_not_start_with_09') }}
              </div>
            </div>

          </div>
        </div>
        <!-- <div class="step-item">
          <div class="step-item-title">Batch reference</div>
          <div> <el-input v-model="batchDisbursement.remark" type="text" autocomplete="off" /></div>
        </div> -->
      </div>

      <!-- <div slot="footer" class="dialog-footer">
        <el-button type="primary" :disabled="submiting" class="btn-submit" @click="onClickSubmitBtn('form')">{{ $t('components.submit') }}</el-button>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
import { fetchReferenceBatchNo } from '@/api/online-transaction/online-transaction.js'
import { download } from '@/utils/common'
export default {
  name: 'Single_Disbursement_Modal',
  components: {
    UploadExcelFile: () => import('../file/PayoutUploadExcelFile.vue')
  },
  props: {
    merchantInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    balance: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      batchDisbursement: { withdrawMoney: 0 },
      dialogVisible: false, // 控制弹框显示隐藏
      submiting: false,
      reference_batch_no: null
    }
  },
  methods: {
    // 改变弹框状态
    showModal() {
      this.reference_batch_no = null
      this.getReferenceBatchNo()
      this.dialogVisible = true
    },
    getReferenceBatchNo() {
      fetchReferenceBatchNo().then(res => {
        if (res.code === 10000) {
          this.reference_batch_no = res.data
        }
      })
    },
    templateFileSuccess() {
      this.dialogVisible = false
      // this.$store.commit('app/SET_SHOW_DOWNLOAD_LIST', true)
      this.$message({ type: 'success', showClose: true, duration: 5000, message: 'Upload completed, the Results Report can be downloaded in ‘Batch Payment Details’ module.' })
      this.$emit('updateList')
    },
    onClickDownloadBtn() {
      let url = ''
      switch (this.$store.getters.curCountry.country_code) {
        case 'PH':
          url = 'https://ulock-public.s3.ap-southeast-1.amazonaws.com/source/Batch_SendPayments_Template_PH_V1.1.xlsx'
          break
        case 'TH':
          url = 'https://ulock-public.s3.ap-southeast-1.amazonaws.com/source/Batch_SendPayments_Template_TH_V1.1.xlsx'
          break
        case 'ID':
          url = 'https://ulock-public.s3.ap-southeast-1.amazonaws.com/source/Batch_SendPayments_Template_ID_V1.1.xlsx'
          break
        case 'VN':
          url = 'https://ulock-public.s3.ap-southeast-1.amazonaws.com/source/Batch_SendPayments_Template_VN_V1.0.xlsx'
          break
        default:
          break
      }
      download(url, '_blank')
    }
  }
}
</script>

<style scoped>
.batchDisbursementModal{
  word-break: keep-all;
}
.batch-tip{
  color: #5E6E82;
  font-size: 12px;
  font-weight: 400;
  padding: 5px 0;
  margin-bottom: 12px;
  border-bottom: 1px solid rgba(54, 66, 80, 0.10);
}
.batch-tip-2{
  font-size: 14px;
  font-weight: 600;
  margin-top: 24px;
  margin-bottom: 12px;
  color: #488CE8;
}
.batch-tip-content{
  display: flex;
  color: #5E6E82;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  word-break: keep-all;
}
.step{
  display: flex;
}
.step-item{
  flex: 1;
  margin-bottom: 20px;
}
.step-item-left{
  width: 350px;
  word-break: keep-all;
}
.download-container{
  height: 162px;
  border-radius: 4px;
  border: 1px solid rgba(54, 66, 80, 0.10);
  display: flex;
  justify-content: center;
  align-items: center;
}
.download-middle{
  width: 400px;
  text-align: center;
}
.download-title-text{
  color: #364250;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 8px;
}
.download-title-text-2{
  margin-top: 8px;
  color: rgba(94, 110, 130, 0.50);
  font-size: 12px;
  font-weight: 400;
}
.section-step-title{
  margin-bottom: 12px;
  font-weight: 500;  font-family: 'Poppins-Medium';
  font-size: 14px;
  line-height: 1.2;
  background: linear-gradient(180deg, #488CE8 0%, #0058CF 100%);
background-clip: text;
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;;
}
.situations-tip{
  margin-bottom: 10px;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.2;
  color: #71110e;
}
.btn-download{
  font-weight: 400;
  font-size: 15px;
}
.tip{
  font-size: 14px;
  font-weight: 400;
  color: #303133;
}
.dialog-footer{
  margin-top: -16px;
  text-align: center;
}
.btn-submit{
  margin-bottom: 4px;
  width: 120px;
  height: 40px;
  background: #0F68E0;
  border-radius: 100px;
}
</style>
